/*
 * File: NoMoreAbout.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 9, 2025 at 5:10 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 31, 2025 at 4:31 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 100%;
	padding: 0px 0px 100px;
	display: flex;
	flex-direction: column;
`;

export const PartnerSection = styled.div`
	margin: 80px auto 50px;
	max-width: 700px;

	* {
		line-height: 180%;
	}
	p {
		font-size: 1.3rem;
	}
	.partner-emphasis {
		font-size: 3rem;
		line-height: 1.3;
		margin-right: 8px;
	}
`;

export const PartnerHeroSection = styled(PartnerSection)`
	margin: 180px auto 120px;
	text-align: left;
`;

export const PartnerContactSection = styled(PartnerSection)``;
